module.exports = __webpack_public_path__ + "static/media/08.32d111e1.png";